import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyEInvoicePrintableFormatHdrContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
    providedIn: "root",
  })
  export class CompanyEInvoicePrintableFormatHdrService extends BaseApiTemplateService<CompanyEInvoicePrintableFormatHdrContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "company/e-invoice/printable-format-hdrs/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "company/e-invoice/printable-format-hdrs/backoffice-ep";
        this.httpClient = http;
      }
  }
